import { render } from "./LogbookClickableUser.vue?vue&type=template&id=ac0a223e"
import script from "./LogbookClickableUser.vue?vue&type=script&lang=js"
export * from "./LogbookClickableUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__